// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-container {
  width: 280px;
  min-width: 280px;
  padding: 6px 0 0;
  display: flex;
  flex-direction: column;
}
.setting-container {
  position: relative;
  flex: 1 1 auto;
  overflow: auto;
}
.setting-container .sidebar-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #FFF;
  z-index: 1;
}
.add-photo-date-btn {
  margin-top: 4px;
}
.text-watermark-title {
  width: 100%;
  height: 40px;
  font-size: 16px;
  font-weight: 800;
  color: black;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid #e0e0e0;
  padding: 0 16px;
}
.setting-group {
  flex: 0 0 auto;
  padding: 16px;
}
.line-container {
  margin: 5px 0;
}
.near-bottom {
  flex: 0 1 auto;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  margin-bottom: 24px;
  margin-top: 36px;
}
.line-center {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.water-mark-type {
  width: 100%;
}
.water-mark-type-btn {
  width: 50%;
}
.font-select {
  width: 100%;
}
.line-left {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.label {
  font-size: 14px;
  font-weight: bold;
  margin: 24px 0 12px 0;
}
.flex-end {
  justify-content: flex-end;
}
.sidebar-textarea {
  width: 100%;
  border-radius: 6px;
  border: none;
  resize: none;
  background-color: rgba(0, 0, 0, 0.04);
}
.text {
  font-size: 14px;
  display: flex;
  align-items: center;
}
.grid-selector-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.pos-type-row {
  margin: 12px 0;
}
.near-bottom-btn {
  margin-right: 16px;
}
.alert-warning {
  margin-bottom: 16px;
}
.button-group {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background-color: rgba(0, 0, 0, 0.04);
  padding: 1px;
}
.button-group-item {
  height: 28px;
  margin: 1px 2px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/Sidebar.less"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AACJ;AAEA;EACI,kBAAA;EACA,cAAA;EACA,cAAA;AAAJ;AAHA;EAMQ,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,UAAA;AAAR;AAIA;EACI,eAAA;AAFJ;AAKA;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,gCAAA;EACA,eAAA;AAHJ;AAMA;EACI,cAAA;EACA,aAAA;AAJJ;AAOA;EACI,aAAA;AALJ;AAQA;EACI,cAAA;EACA,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;AANJ;AASA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAPJ;AAUA;EACI,WAAA;AARJ;AAWA;EACI,UAAA;AATJ;AAYA;EACI,WAAA;AAVJ;AAaA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;AAXJ;AAcA;EACI,eAAA;EACA,iBAAA;EACA,qBAAA;AAZJ;AAeA;EACI,yBAAA;AAbJ;AAgBA;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,qCAAA;AAdJ;AAiBA;EACI,eAAA;EACA,aAAA;EACA,mBAAA;AAfJ;AAkBA;EACI,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAhBJ;AAmBA;EACI,cAAA;AAjBJ;AAoBA;EACI,kBAAA;AAlBJ;AAqBA;EACI,mBAAA;AAnBJ;AAsBA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qCAAA;EACA,YAAA;AApBJ;AAuBA;EACI,YAAA;EACA,eAAA;AArBJ","sourcesContent":[".sidebar-container {\n    width: 280px;\n    min-width: 280px;\n    padding: 6px 0 0;\n    display: flex;\n    flex-direction: column;\n}\n\n.setting-container {\n    position: relative;\n    flex: 1 1 auto;\n    overflow: auto;\n\n    .sidebar-mask {\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background-color:#FFF;\n        z-index: 1;\n    }\n}\n\n.add-photo-date-btn {\n    margin-top: 4px;\n}\n\n.text-watermark-title {\n    width: 100%;\n    height: 40px;\n    font-size: 16px;\n    font-weight: 800;\n    color: black;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    border-bottom: 1px solid #e0e0e0;\n    padding: 0 16px;\n}\n\n.setting-group {\n    flex: 0 0 auto;\n    padding: 16px;\n}\n\n.line-container {\n    margin: 5px 0;\n}\n\n.near-bottom {\n    flex: 0 1 auto;\n    display: flex;\n    justify-content: center;\n    align-items: flex-end;\n    margin-bottom: 24px;\n    margin-top: 36px;\n}\n\n.line-center {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.water-mark-type {\n    width: 100%;\n}\n\n.water-mark-type-btn {\n    width: 50%;\n}\n\n.font-select {\n    width: 100%;\n}\n\n.line-left {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n.label {\n    font-size: 14px;\n    font-weight: bold;\n    margin: 24px 0 12px 0;\n}\n\n.flex-end {\n    justify-content: flex-end;\n}\n\n.sidebar-textarea {\n    width: 100%;\n    border-radius: 6px;\n    border: none;\n    resize: none;\n    background-color: rgba(0, 0, 0, 0.04);\n}\n\n.text {\n    font-size: 14px;\n    display: flex;\n    align-items: center;\n}\n\n.grid-selector-container {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.pos-type-row {\n    margin: 12px 0;\n}\n\n.near-bottom-btn {\n    margin-right: 16px;\n}\n\n.alert-warning {\n    margin-bottom: 16px;\n}\n\n.button-group {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 8px;\n    background-color: rgba(0, 0, 0, 0.04);\n    padding: 1px;\n}\n\n.button-group-item {\n    height: 28px;\n    margin: 1px 2px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
